import script from "./YContentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./YContentModal.vue?vue&type=script&setup=true&lang=js"

import "./YContentModal.vue?vue&type=style&index=0&id=626d5bf8&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/线上短信平台/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-626d5bf8"]])

export default __exports__